<template>
  <div class="billboard-carousel">
    <Carousel
      v-if="billboards.length > 0"
      alt-prev-text="Previous"
      alt-next-text="Next"
      lazy-load="progressive"
      :class="{ 'with-tnc': hasTncBillboards.length }"
      :autoplay="true"
      :autoplay-speed="7000"
      :dots="true"
      :arrows="false"
      :infinite="true"
      :pause-on-dots-hover="true"
      :pause-on-hover="true"
      :speed="1000"
      :swipe="true"
    >
      <Billboard
        v-for="billboard in billboards"
        :key="billboard.id"
        :billboard="billboard"
      />
    </Carousel>
  </div>
</template>

<script>
import Carousel from '@sephora-asia/core-carousel/Carousel.vue'
import Billboard from './Billboard.vue'

export default {
  name: 'BrandBillboardCarousel',

  components: {
    Billboard,
    Carousel
  },

  props: {
    billboards: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    hasTncBillboards() {
      return this.billboards.filter((billboard) => billboard.termsAndConditions)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .carousel {
  .slick-slide {
    padding-left: 0;
    padding-right: 0;
  }

  &.with-tnc {
    .terms-and-conditions-container {
      min-height: 20px;
    }
  }
}
</style>
